import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { GetRailProps } from "react-compound-slider";

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 42,
  transform: "translate(0%, -50%)",
  borderRadius: 9,
  cursor: "pointer",
  // border: '1px solid white',
};

const railInnerStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 13,
  transform: "translate(0%, -50%)",
  borderRadius: 9,
  pointerEvents: "none",
  background: "linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 99.01%), #414042",
};

type Props = {
  getRailProps: GetRailProps;
};

export default function ImageLevellingSliderRail({ getRailProps }: Props) {
  return (
    <Fragment>
      <div style={railOuterStyle} {...getRailProps()} />
      <div style={railInnerStyle} />
    </Fragment>
  );
}

ImageLevellingSliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
};
